/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Preview_FixInputs */

const vi_irrigation_schedule_preview_fix = /** @type {(inputs: Irrigation_Schedule_Preview_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa các ô báo lỗi để xem trước`)
};

/**

* @param {Irrigation_Schedule_Preview_FixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_preview_fix = /** @type {((inputs?: Irrigation_Schedule_Preview_FixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Preview_FixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_preview_fix(inputs)
});